/* eslint-disable import/no-extraneous-dependencies */
import React from 'react';
import DatePicker, { registerLocale } from 'react-datepicker';
import { ru } from 'date-fns/locale';
import 'react-datepicker/dist/react-datepicker.css';
import './DateCalendar.scss';
import { DateType } from '../DateLocal/DateLocal';

registerLocale('ru', ru);

interface Props {
  value: Date | undefined
  onChange: (date: Date | undefined, isIncorrect?: boolean) => void
  type: DateType
  disabled?: boolean
  minDate?: Date
}

export const DateCalendar = ({ value, onChange, type, disabled, minDate }: Props) => {
  return (
    disabled ? (
      <div className="dateCalendar">
        <div className="dateCalendarButton">
          <svg
            width="25px"
            height="25px"
            viewBox="0 0 1275 1218"
            version="1.1"
            // className={className}
            xmlns="http://www.w3.org/2000/svg"
          >
            <g>
              <path
                fill="#A9A9A9"
                opacity="1.00"
                d=" M 326.53 23.69 C 340.98 20.53 356.56 23.22 369.25 30.79 C 386.86 41.00 398.19 60.80 398.52 81.10 C 398.66 116.41 398.48 151.72 398.61 187.03 C 398.52 195.06 398.90 203.14 397.73 211.11 C 394.90 230.23 382.03 247.55 364.48 255.67 C 354.47 260.49 343.10 262.38 332.07 261.14 C 315.68 259.40 300.18 250.42 290.55 237.04 C 283.00 226.67 278.82 213.86 278.99 201.02 C 278.92 164.02 279.02 127.03 278.91 90.03 C 278.87 80.26 279.18 70.19 282.90 61.01 C 289.75 42.16 306.91 27.65 326.53 23.69 Z"
              />
              <path
                fill="#A9A9A9"
                opacity="1.00"
                d=" M 924.43 23.67 C 950.77 17.57 980.00 32.43 990.84 57.14 C 994.76 65.52 996.41 74.83 996.48 84.04 C 996.26 123.35 996.57 162.66 996.35 201.98 C 996.33 216.13 991.01 230.17 981.81 240.91 C 964.28 261.90 931.52 267.80 907.81 254.13 C 889.01 244.11 876.76 223.23 876.83 201.98 C 876.78 166.97 876.86 131.96 876.77 96.95 C 876.79 85.06 876.12 72.70 880.58 61.42 C 887.26 42.30 904.67 27.65 924.43 23.67 Z"
              />
              <path
                fill="#a9a9a9"
                opacity="1"
                d="m 72.57,179.49 c 19.39,-20.63 46.38,-34.03 74.58,-36.79 30.62,-1.58 61.29,-0.41 91.93,-0.69 0.04,22 0.12,44 0.03,66 -0.11,21.74 6.59,43.65 19.79,61.03 17.35,23.69 45.76,38.87 75.11,40.05 23.84,1.45 47.85,-6.72 66.54,-21.42 23.52,-18.39 37.72,-47.91 37.83,-77.72 0.03,-22.65 0,-45.3 0.04,-67.95 132.84,-0.06 265.68,-0.09 398.52,0.03 0.03,22.31 0.1,44.62 0.03,66.93 -0.15,21.74 6.95,43.55 20.25,60.79 21.33,28.96 59.29,44.2 94.74,38.37 28.49,-4.48 54.86,-21.79 69.63,-46.67 9.73,-15.98 15.08,-34.7 14.62,-53.45 0.07,-22 0.01,-44.01 0.05,-66.01 27.92,0.02 55.84,-0.19 83.75,0.08 40.99,0.79 80.2,25.16 100.2,60.76 9.22,16.66 14.64,35.48 15.27,54.55 0.15,6.86 0.02,13.72 0.06,20.59 0.01,255.34 0.06,510.69 -0.03,766.03 -0.14,10.37 0.49,20.81 -1.01,31.11 -4.74,34.67 -25.75,66.54 -55.33,85.11 -14.02,8.66 -29.81,14.74 -46.22,16.73 -14.24,1.83 -28.63,1.37 -42.95,1.31 -308.99,0 -617.98,0.01 -926.96,-0.01 -25.18,0.5 -50.68,-6.56 -71.42,-21 -25.54,-17.73 -43.9,-45.6 -49.77,-76.16 -2.63,-12.53 -1.89,-25.38 -2.01,-38.09 -0.02,-258.01 -0.03,-516.02 0.01,-774.03 0.03,-5.34 -0.12,-10.69 0.31,-16.01 2.01,-27.22 13.56,-53.69 32.41,-73.47 m 47.08,233.44 c -0.17,185 -0.04,451 -0.07,636 -0.01,3.38 -0.08,6.8 0.57,10.15 3.22,18.11 20.36,32.88 38.9,32.58 319.66,-0.05 639.32,0.14 958.97,-0.12 16.46,-0.43 31.48,-12.65 36.15,-28.28 2.48,-7.88 1.25,-16.22 1.56,-24.33 0.16,-181.69 0.06,-444.38 0.05,-626.07 -345.38,0.01 -690.75,-0.11 -1036.13,0.07 z"
              />
              <path
                fill="#a9a9a9"
                opacity="1"
                d="m 449.06824,510.2395 c 47.61498,-0.14742 95.22101,-0.1081 142.83601,0 0.0269,39.12568 0.14342,78.26121 -0.018,117.39671 -47.62396,0.13762 -95.2479,0.12778 -142.87187,-0.01 0.027,-39.12568 -0.0897,-78.2612 0.0538,-117.38688 z"
              />
              <path
                fill="#a9a9a9"
                opacity="1"
                d="m 675.53619,510.25624 c 47.62395,-0.15725 95.24789,-0.14742 142.87186,0.01 -0.0629,39.13552 0.0806,78.27104 -0.0544,117.40655 -47.61505,0.11794 -95.22108,0.0688 -142.8271,0 -0.0539,-39.14534 -0.16136,-78.28086 0.01,-117.41638 z"
              />
              <path
                fill="#a9a9a9"
                opacity="1"
                d="m 222.6347,693.81974 c 47.59707,-0.0982 95.2031,-0.15725 142.80014,0.01 0.1255,39.13551 0.0718,78.27104 0.01,117.40656 -47.60602,0.059 -95.20308,0.14742 -142.8091,-0.01 -0.1524,-39.13552 -0.0717,-78.27104 0,-117.40655 z"
              />
              <path
                fill="#a9a9a9"
                opacity="1"
                d="m 449.04656,693.53865 c 47.60603,-0.0787 95.21206,-0.0294 142.81806,-0.0393 0.13446,39.16499 0.14343,78.33001 0.01,117.48518 -47.59706,0.059 -95.19412,0.13759 -142.79117,-0.01 -0.18825,-39.14535 -0.0358,-78.2907 -0.0358,-117.43605 z"
              />
              <path
                fill="#a9a9a9"
                opacity="1"
                d="m 675.51359,693.56046 c 47.61499,-0.12777 95.22101,-0.0787 142.83608,0 0.0358,39.13552 0.14333,78.2612 -0.0272,117.39673 -47.62395,0.15724 -95.23895,0.12776 -142.86288,0.01 0.0359,-39.13552 -0.0897,-78.27104 0.0537,-117.40654 z"
              />
              <path
                fill="#a9a9a9"
                opacity="1"
                d="m 222.64204,876.92653 c 47.59707,-0.12776 95.19413,-0.14742 142.80013,-0.01 0.17929,39.15518 0.018,78.31034 0.0449,117.46553 -47.61498,0.01 -95.22998,0.0393 -142.83601,0 -0.13444,-39.15519 -0.13444,-78.30052 -0.01,-117.4557 z"
              />
              <path
                fill="#a9a9a9"
                opacity="1"
                d="m 449.08039,876.92379 c 47.60602,-0.1081 95.20308,-0.15725 142.80911,-0.01 0.14343,39.13552 0.0628,78.28087 0,117.41639 -47.59706,0.059 -95.20309,0.13759 -142.80013,-0.01 -0.15239,-39.13552 -0.0807,-78.2612 -0.01,-117.39672 z"
              />
              <path
                fill="#a9a9a9"
                opacity="1"
                d="m 675.49084,876.85514 c 47.60604,-0.059 95.22103,-0.0197 142.82709,-0.0294 0.14346,39.15517 0.12544,78.32018 0.0179,117.48519 -47.5971,0.0885 -95.19415,0.11793 -142.80018,-0.0197 -0.19721,-39.14535 -0.027,-78.29069 -0.0448,-117.43605 z"
              />
              <path
                fill="#a9a9a9"
                opacity="1"
                d="m 901.98152,510.25624 c 47.62398,-0.15725 95.24799,-0.14742 142.87188,0.01 -0.063,39.13552 0.081,78.27104 -0.053,117.40655 -47.61499,0.11794 -95.22106,0.0688 -142.82707,0 -0.0541,-39.14534 -0.16134,-78.28086 0.01,-117.41638 z"
              />
              <path
                fill="#a9a9a9"
                opacity="1"
                d="m 901.96362,693.56045 c 47.61499,-0.12777 95.221,-0.0787 142.83608,0 0.036,39.13552 0.1433,78.2612 -0.028,117.39673 -47.62402,0.15724 -95.23897,0.12777 -142.86288,0.01 0.0358,-39.13552 -0.0899,-78.27104 0.0541,-117.40654 z"
              />
              <path
                fill="#a9a9a9"
                opacity="1"
                d="m 901.93675,876.85519 c 47.606,-0.0591 95.22092,-0.0197 142.82705,-0.0295 0.1436,39.1552 0.1253,78.32025 0.018,117.48519 -47.59718,0.0886 -95.19421,0.11794 -142.80022,-0.0197 -0.1972,-39.14535 -0.0267,-78.29061 -0.0449,-117.43596 z"
              />
            </g>
          </svg>
        </div>
      </div>
    ) : (
      <div className="dateCalendar">
        <DatePicker
          selected={value}
          onChange={
            (date: Date | null) => {
              let newDate = date;
              if (date && (!value || (date.getHours() !== value?.getHours() || date.getMinutes() !== value?.getMinutes()))) {
                newDate = value ? value! : date;
                newDate!.setHours(date.getHours());
                newDate!.setMinutes(date.getMinutes());
              }
              const utcDate = new Date(Date.UTC(newDate!.getFullYear(), newDate!.getMonth(), newDate!.getDate(), 0, 0, 0));
              onChange(type === DateType.date ? utcDate : newDate!, false);
            }
          }
          minDate={minDate}
          dateFormat={type === DateType.date ? 'yyyy-MM-dd' : 'yyyy-MM-dd HH:mm'}
          locale="ru"
          customInput={
            <div className="dateCalendarButton">
              <svg
                width="25px"
                height="25px"
                viewBox="0 0 1275 1218"
                version="1.1"
                // className={className}
                xmlns="http://www.w3.org/2000/svg"
              >
                <g>
                  <path
                    fill="#A9A9A9"
                    opacity="1.00"
                    d=" M 326.53 23.69 C 340.98 20.53 356.56 23.22 369.25 30.79 C 386.86 41.00 398.19 60.80 398.52 81.10 C 398.66 116.41 398.48 151.72 398.61 187.03 C 398.52 195.06 398.90 203.14 397.73 211.11 C 394.90 230.23 382.03 247.55 364.48 255.67 C 354.47 260.49 343.10 262.38 332.07 261.14 C 315.68 259.40 300.18 250.42 290.55 237.04 C 283.00 226.67 278.82 213.86 278.99 201.02 C 278.92 164.02 279.02 127.03 278.91 90.03 C 278.87 80.26 279.18 70.19 282.90 61.01 C 289.75 42.16 306.91 27.65 326.53 23.69 Z"
                  />
                  <path
                    fill="#A9A9A9"
                    opacity="1.00"
                    d=" M 924.43 23.67 C 950.77 17.57 980.00 32.43 990.84 57.14 C 994.76 65.52 996.41 74.83 996.48 84.04 C 996.26 123.35 996.57 162.66 996.35 201.98 C 996.33 216.13 991.01 230.17 981.81 240.91 C 964.28 261.90 931.52 267.80 907.81 254.13 C 889.01 244.11 876.76 223.23 876.83 201.98 C 876.78 166.97 876.86 131.96 876.77 96.95 C 876.79 85.06 876.12 72.70 880.58 61.42 C 887.26 42.30 904.67 27.65 924.43 23.67 Z"
                  />
                  <path
                    fill="#a9a9a9"
                    opacity="1"
                    d="m 72.57,179.49 c 19.39,-20.63 46.38,-34.03 74.58,-36.79 30.62,-1.58 61.29,-0.41 91.93,-0.69 0.04,22 0.12,44 0.03,66 -0.11,21.74 6.59,43.65 19.79,61.03 17.35,23.69 45.76,38.87 75.11,40.05 23.84,1.45 47.85,-6.72 66.54,-21.42 23.52,-18.39 37.72,-47.91 37.83,-77.72 0.03,-22.65 0,-45.3 0.04,-67.95 132.84,-0.06 265.68,-0.09 398.52,0.03 0.03,22.31 0.1,44.62 0.03,66.93 -0.15,21.74 6.95,43.55 20.25,60.79 21.33,28.96 59.29,44.2 94.74,38.37 28.49,-4.48 54.86,-21.79 69.63,-46.67 9.73,-15.98 15.08,-34.7 14.62,-53.45 0.07,-22 0.01,-44.01 0.05,-66.01 27.92,0.02 55.84,-0.19 83.75,0.08 40.99,0.79 80.2,25.16 100.2,60.76 9.22,16.66 14.64,35.48 15.27,54.55 0.15,6.86 0.02,13.72 0.06,20.59 0.01,255.34 0.06,510.69 -0.03,766.03 -0.14,10.37 0.49,20.81 -1.01,31.11 -4.74,34.67 -25.75,66.54 -55.33,85.11 -14.02,8.66 -29.81,14.74 -46.22,16.73 -14.24,1.83 -28.63,1.37 -42.95,1.31 -308.99,0 -617.98,0.01 -926.96,-0.01 -25.18,0.5 -50.68,-6.56 -71.42,-21 -25.54,-17.73 -43.9,-45.6 -49.77,-76.16 -2.63,-12.53 -1.89,-25.38 -2.01,-38.09 -0.02,-258.01 -0.03,-516.02 0.01,-774.03 0.03,-5.34 -0.12,-10.69 0.31,-16.01 2.01,-27.22 13.56,-53.69 32.41,-73.47 m 47.08,233.44 c -0.17,185 -0.04,451 -0.07,636 -0.01,3.38 -0.08,6.8 0.57,10.15 3.22,18.11 20.36,32.88 38.9,32.58 319.66,-0.05 639.32,0.14 958.97,-0.12 16.46,-0.43 31.48,-12.65 36.15,-28.28 2.48,-7.88 1.25,-16.22 1.56,-24.33 0.16,-181.69 0.06,-444.38 0.05,-626.07 -345.38,0.01 -690.75,-0.11 -1036.13,0.07 z"
                  />
                  <path
                    fill="#a9a9a9"
                    opacity="1"
                    d="m 449.06824,510.2395 c 47.61498,-0.14742 95.22101,-0.1081 142.83601,0 0.0269,39.12568 0.14342,78.26121 -0.018,117.39671 -47.62396,0.13762 -95.2479,0.12778 -142.87187,-0.01 0.027,-39.12568 -0.0897,-78.2612 0.0538,-117.38688 z"
                  />
                  <path
                    fill="#a9a9a9"
                    opacity="1"
                    d="m 675.53619,510.25624 c 47.62395,-0.15725 95.24789,-0.14742 142.87186,0.01 -0.0629,39.13552 0.0806,78.27104 -0.0544,117.40655 -47.61505,0.11794 -95.22108,0.0688 -142.8271,0 -0.0539,-39.14534 -0.16136,-78.28086 0.01,-117.41638 z"
                  />
                  <path
                    fill="#a9a9a9"
                    opacity="1"
                    d="m 222.6347,693.81974 c 47.59707,-0.0982 95.2031,-0.15725 142.80014,0.01 0.1255,39.13551 0.0718,78.27104 0.01,117.40656 -47.60602,0.059 -95.20308,0.14742 -142.8091,-0.01 -0.1524,-39.13552 -0.0717,-78.27104 0,-117.40655 z"
                  />
                  <path
                    fill="#a9a9a9"
                    opacity="1"
                    d="m 449.04656,693.53865 c 47.60603,-0.0787 95.21206,-0.0294 142.81806,-0.0393 0.13446,39.16499 0.14343,78.33001 0.01,117.48518 -47.59706,0.059 -95.19412,0.13759 -142.79117,-0.01 -0.18825,-39.14535 -0.0358,-78.2907 -0.0358,-117.43605 z"
                  />
                  <path
                    fill="#a9a9a9"
                    opacity="1"
                    d="m 675.51359,693.56046 c 47.61499,-0.12777 95.22101,-0.0787 142.83608,0 0.0358,39.13552 0.14333,78.2612 -0.0272,117.39673 -47.62395,0.15724 -95.23895,0.12776 -142.86288,0.01 0.0359,-39.13552 -0.0897,-78.27104 0.0537,-117.40654 z"
                  />
                  <path
                    fill="#a9a9a9"
                    opacity="1"
                    d="m 222.64204,876.92653 c 47.59707,-0.12776 95.19413,-0.14742 142.80013,-0.01 0.17929,39.15518 0.018,78.31034 0.0449,117.46553 -47.61498,0.01 -95.22998,0.0393 -142.83601,0 -0.13444,-39.15519 -0.13444,-78.30052 -0.01,-117.4557 z"
                  />
                  <path
                    fill="#a9a9a9"
                    opacity="1"
                    d="m 449.08039,876.92379 c 47.60602,-0.1081 95.20308,-0.15725 142.80911,-0.01 0.14343,39.13552 0.0628,78.28087 0,117.41639 -47.59706,0.059 -95.20309,0.13759 -142.80013,-0.01 -0.15239,-39.13552 -0.0807,-78.2612 -0.01,-117.39672 z"
                  />
                  <path
                    fill="#a9a9a9"
                    opacity="1"
                    d="m 675.49084,876.85514 c 47.60604,-0.059 95.22103,-0.0197 142.82709,-0.0294 0.14346,39.15517 0.12544,78.32018 0.0179,117.48519 -47.5971,0.0885 -95.19415,0.11793 -142.80018,-0.0197 -0.19721,-39.14535 -0.027,-78.29069 -0.0448,-117.43605 z"
                  />
                  <path
                    fill="#a9a9a9"
                    opacity="1"
                    d="m 901.98152,510.25624 c 47.62398,-0.15725 95.24799,-0.14742 142.87188,0.01 -0.063,39.13552 0.081,78.27104 -0.053,117.40655 -47.61499,0.11794 -95.22106,0.0688 -142.82707,0 -0.0541,-39.14534 -0.16134,-78.28086 0.01,-117.41638 z"
                  />
                  <path
                    fill="#a9a9a9"
                    opacity="1"
                    d="m 901.96362,693.56045 c 47.61499,-0.12777 95.221,-0.0787 142.83608,0 0.036,39.13552 0.1433,78.2612 -0.028,117.39673 -47.62402,0.15724 -95.23897,0.12777 -142.86288,0.01 0.0358,-39.13552 -0.0899,-78.27104 0.0541,-117.40654 z"
                  />
                  <path
                    fill="#a9a9a9"
                    opacity="1"
                    d="m 901.93675,876.85519 c 47.606,-0.0591 95.22092,-0.0197 142.82705,-0.0295 0.1436,39.1552 0.1253,78.32025 0.018,117.48519 -47.59718,0.0886 -95.19421,0.11794 -142.80022,-0.0197 -0.1972,-39.14535 -0.0267,-78.29061 -0.0449,-117.43596 z"
                  />
                </g>
              </svg>
            </div>
          }
          // Иконка календаря
          calendarIconClassname={'calendar-icon' as never}
          showYearDropdown
          shouldCloseOnSelect
          showMonthDropdown
          dropdownMode="select"
          showTimeSelect={type === DateType.dateTimeLocal}
          timeFormat="HH:mm"
          timeIntervals={15}
        />
      </div>)
  );
};
